import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { mapState } from '@deerplusofficial/pos-helper';
import CartItemList from './CartItemList';
import CartPreOrderDetail from './CartPreOrderDetail';
import CartPreOrderList from './CartPreOrderList';

class CartBody extends React.PureComponent {
  static propTypes = {
    readonly: PropTypes.bool,
    isShowInputTotalPriceEditor: PropTypes.bool,
    toggleInputTotalPriceEditor: PropTypes.func,
    preOrder: PropTypes.shape({
      isListOpen: PropTypes.bool,
      isDetailOpen: PropTypes.bool,
    }),
  };

  static defaultProps = {
    readonly: false,
    isShowInputTotalPriceEditor: false,
    toggleInputTotalPriceEditor: _.identity,
    preOrder: {},
  };

  render() {
    const {
      isShowInputTotalPriceEditor,
      toggleInputTotalPriceEditor,
      readonly,
      preOrder: { isListOpen, isDetailOpen },
    } = this.props;

    if (isDetailOpen) return <CartPreOrderDetail />;

    if (isListOpen) return <CartPreOrderList />;

    return (
      <CartItemList
        manually={isShowInputTotalPriceEditor}
        readonly={readonly}
        toggleManually={toggleInputTotalPriceEditor}
      />
    );
  }
}

export default connect(mapState(['preOrder']))(CartBody);



// WEBPACK FOOTER //
// ./src/components/Cart/CartBody.js